//登录相关接口请求
import request from "@/utils/request";
const publicAuthConfig = {
  skipAuthRedirect: true,
  skipErrorMessage: true,
};
const loginAuthConfig = {
  skipAuthRedirect: true,
};
//获取图形验证码
export const getPicCode = () => {
  return request.get("/api/mts-api/captcha/image", publicAuthConfig);
};

//获取短信验证码
export const getMsgCode = (mobile, countryCode = "+86", scene = "common") => {
  return request.post(
    "/api/mts-api/sms/getMobileVerificationCode",
    { countryCode, mobile: mobile, scene },
    publicAuthConfig,
  );
};

// 获取邮箱验证码
export const sendEmailCode = (email, scene = "register") => {
  return request.post(
    "/api/mts-api/sendEmailCode",
    { email, scene },
    publicAuthConfig,
  );
};
// export const getMsgCode = (captchaCode, captchaKey, mobile) => {
//   return request.post('/api/mts-api/sms/getMobileVerificationCode',
//       {
//         mobile: mobile
//       })
// }

//登录接口
export const codeLogin = (mobile, smsCode, countryCode = "+86") => {
  return request.post(
    "/api/mts-api/login",
    { countryCode, mobile, smsCode },
    loginAuthConfig,
  );
};

// 邮箱验证码登录，个人和企业账号共用。
export const emailCodeLogin = (email, emailCode) =>
  request.post("/api/mts-api/emailLogin", { email, emailCode }, loginAuthConfig);

// 密码登录
export const passwordLogin = (account, password) => {
  return request.post(
    "/api/mts-api/passwordLogin",
    { username: account, password },
    loginAuthConfig,
  );
};

// 注册
export const registerUser = (data) => {
  return request.post("/api/mts-api/register", data, publicAuthConfig);
};

//微信登录接口
export const wxLogin = (jsCode, corpId) => {
  return request.post(
    "/api/mts-api/wxLogin",
    { jsCode, corpId }, //这里其实应该是code，但是接口参数没改
    publicAuthConfig,
  );
};

//pc端-微信登录二维码生成接口
export const getWxmpCode = (uuid) => {
  return request.post("/api/mts-api/getWxmpCode", { uuid }, publicAuthConfig);
};

// 轮询接口
/**
 *
 * @param {} uuid
 * @param {*} ticket
 * @returns
 */
export const selectWxmpLoginStatus = (uuid, ticket) => {
  return request.post(
    "/api/mts-api/selectWxmpLoginStatus",
    { uuid, ticket },
    publicAuthConfig,
  );
};

/**
 * 用户绑定手机号
 * @param {string} mobile
 * @param {string} code 验证码
 */
export const bindMobile = (mobile, code) => {
  return request.post("/api/mts-api/user/bindMobile", { mobile, code });
};

// Google Identity Services：客户端仅提交 ID Token，不使用 Client Secret。
const googleAuthConfig = { ...publicAuthConfig, skipLoading: true };
export const getGoogleLoginConfig = () =>
  request.get("/api/mts-api/googleLogin/config", googleAuthConfig);

export const getGoogleLoginChallenge = () =>
  request.post("/api/mts-api/googleLogin/challenge", {}, googleAuthConfig);

export const googleLogin = (data) =>
  request.post("/api/mts-api/googleLogin", data, { ...googleAuthConfig, timeout: 20000 });

export const sendPasswordResetCode = (data) => request.post('/api/mts-api/password-reset/send-code', data, publicAuthConfig);
export const resetPassword = (data) => request.post('/api/mts-api/password-reset/confirm', data, publicAuthConfig);
